// Shared typography copied from the consultant dashboard theme
// (components/ConsultantDashboard/ConsultantTheme.js) so the whole app uses the
// same font family, sizes and weights.
//
// Spread this LAST into each MUI theme's `typography` block so it overrides any
// theme-specific fontFamily / h5 / h6 / button while leaving other variants
// (h1–h4 sizes, body, etc.) intact:
//
//   typography: { ...existing, ...appTypography }
//
// Note: per-variant fontFamily overrides (e.g. a display font on h1–h4) still
// win over the top-level fontFamily here — point those variables at
// APP_FONT_FAMILY too if you want headings in Inter.

export const APP_FONT_FAMILY =
  "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif";

export const appTypography = {
  fontFamily: APP_FONT_FAMILY,
  // Match the consultant dashboard's weight + body sizing (MUI defaults), so
  // themes that shrink these (e.g. abisinya: body 14/13px, bold capped at 500)
  // are brought back up to the consultant dashboard's scale.
  fontWeightBold: 700,
  h5: { fontWeight: 600, fontSize: "1.2rem" },
  h6: { fontWeight: 600, fontSize: "1.0rem" },
  subtitle1: { fontSize: "1rem" },     // 16px
  body1: { fontSize: "1rem" },         // 16px
  body2: { fontSize: "0.875rem" },     // 14px
  button: { textTransform: "none", fontWeight: 600 },
};
